export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  watch: {
    data: {
      handler(v) {
        this.curImgae = v[0];
        this.arr = v;
      },
      immediate: true
    }
  },
  data() {
    return {
      arr: this.data,
      bili: 0,
      curImgae: this.data[0]
    };
  },
  created() {},
  mounted() {
    this.getImageMagnifier();
    window.onresize = () => {
      this.getImageMagnifier();
    };
  },
  methods: {
    getImageMagnifier() {
      let smallbox = this.$refs.smallbox;
      let bigbox = this.$refs.bigbox;
      let bigimg = this.$refs.bigimg;
      bigbox.style.display = "block";
      this.bili = parseInt(getComputedStyle(bigbox).width) / parseInt(getComputedStyle(this.$refs.zhao).width);
      bigbox.style.display = "none";
      bigimg.style.width = `${this.bili * smallbox.offsetWidth}px`;
      bigimg.style.height = `${this.bili * smallbox.offsetHeight}px`;
    },
    onmousemove(e) {
      let bili = this.bili;
      let zhao = this.$refs.zhao;
      let smallbox = this.$refs.smallbox;
      let bigimg = this.$refs.bigimg;
      let ev = e || window.event;
      let ox = ev.offsetX;
      let oy = ev.offsetY;
      let left = ox - zhao.offsetWidth / 2;
      let top = oy - zhao.offsetHeight / 2;
      if (left < 0) {
        left = 0;
      }
      if (top < 0) {
        top = 0;
      }
      // 边界判断,减轻边框2
      if (left > smallbox.offsetWidth - zhao.offsetWidth) {
        left = smallbox.offsetWidth - zhao.offsetWidth - 2;
      }
      if (top > smallbox.offsetHeight - zhao.offsetHeight) {
        top = smallbox.offsetHeight - zhao.offsetHeight - 2;
      }
      // 开始进行赋值
      zhao.style.left = `${left}px`;
      zhao.style.top = `${top}px`;
      // 大图片移动的方向一定是往相反的方向
      bigimg.style.marginLeft = `${-bili * left}px`;
      bigimg.style.marginTop = `${-bili * top}px`;
    },
    onmoueseenter() {
      // 去掉图片放大
      // this.$refs.zhao.style.display = 'block';
      // this.$refs.bigbox.style.display = 'block';
    },
    onmoueseLeave() {
      this.$refs.zhao.style.display = "none";
      this.$refs.bigbox.style.display = "none";
    },
    onImageClick(item) {
      if (item) {
        this.curImgae = item;
      }
    }
  }
};